/**
 * Custom Validators for Step 2
 */

import { JobPostFormData } from '../../../schemas/jobPostValidation';
import { RequirementState } from './formTransformers';

/**
 * Validate individual requirement
 */
export const validateRequirement = (requirement: RequirementState): { valid: boolean; error?: string } => {
  const trimmedDescription = requirement.description.trim();
  
  if (!trimmedDescription) {
    return { valid: false, error: 'Requirement description is required' };
  }
  
  return { valid: true };
};

/**
 * Check for duplicate requirements
 * Returns indices of duplicate requirements (same description after trim)
 */
export const checkDuplicateRequirements = (requirements: RequirementState[]): number[] => {
  const duplicateIndices: number[] = [];
  const seenDescriptions = new Map<string, number[]>();

  requirements.forEach((req, index) => {
    const trimmedDescription = req.description.trim().toLowerCase();
    if (trimmedDescription) {
      if (!seenDescriptions.has(trimmedDescription)) {
        seenDescriptions.set(trimmedDescription, [index]);
      } else {
        const indices = seenDescriptions.get(trimmedDescription)!;
        indices.push(index);
        if (indices.length > 1) {
          duplicateIndices.push(...indices);
        }
      }
    }
  });

  return Array.from(new Set(duplicateIndices)); // Remove duplicates
};

/**
 * Validation rules for requirement description
 */
export const requirementValidationRules = [
  { required: true, message: 'Requirement description is required' },
];

